import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_UPDATE_ADDRESS,
  WARRANTY_UPDATE_ZIP_CODE,
  WARRANTY_UPDATE_PROPERTY_TYPE,
  WARRANTY_UPDATE_RESIDENT_TYPE,
  WARRANTY_UPDATE_MORE_THAN_TWO_YEARS,
  WARRANTY_UPDATE_COORDINATES,
  WARRANTY_UPDATE_PROPS,
  WARRANTY_UPDATE_SHOW_EXTRA_INFO,
  USER_MODULE_NAME
} from '@/store/types'
import maInputText from '@/components/input/modules/text'
import maInputRadio from '@/components/input/modules/radio'
import maInputBtn from '@/components/input/modules/btn'
import maAccordion from '@/components/accordion'
import maEventBus from '@/components/eventbus'
import maInputSelect from '@/components/input/modules/select'
import maModal from '@/components/modal'
import maMoreInfoModal from '@/components/modal/modules/moreInfoModal'
import { hasClass } from '@/utils/classes.js'
import setTimeStamp from '@/utils/timeStamp.js'
import { apiCreateSinister } from '@/services/API/createSinister'
import { getSelfcareLinkData, apiPostSinister } from '@/services/API/sinister'
import { apiGetGenericFormsList, apiGetFnolIds } from '@/services/API/menus'
import { apiGetFlows } from '@/services/API/flow'
import { apiPostTrackTMO } from '@/services/API/timeStamp'
import { getUser } from '@/services/API/authentication'
import * as Settings from '@/infra/settings'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import validateEmail from '@/utils/validation'

import {
  AGENT_ROLE,
  ALLIANZ_FRANCE_ROLE,
  EMAIL,
  SMS,
  EMAIL_MASK
} from '@/constants'

export default {
  name: 'warrantyProps',
  data: function() {
    return {
      place: {},
      panorama: null,
      service: null,
      linkSelfCare: 'linkSelfCare',
      showLinkSelfcare: false,
      selfcareForms: [],
      selfcareFormsValue: null,
      selfcareClientPhone: null,
      selfcareClientPhoneNew: null,
      selfcareClientPhoneCountry: null,
      selfcareClientEmail: null,
      selfcareClientEmailRaw: null,
      selfcareFnolIds: [],
      selfcareFnolIdsValue: null,
      selfcareFlows: [],
      selfcareFlowsValue: null,
      selfcareAgencyCode: null,
      timeStampStart: null,
      timeStampFinish: null,
      countryCode: null,
      resultsExample: null,
      selfcareValidationTypeOptions: [
        { key: null, literal: this.$t('common.noSelected') },
        {
          key: SMS,
          literal: 'SMS'
        },
        {
          key: EMAIL,
          literal: 'Email'
        }
      ],
      selfcareValidationTypeValue: null,
      propertyTypeOptions: [{
        key: 'appartement',
        literal: 'warrantyProps.propertyType.options.appartment'
      },
      {
        key: 'maison',
        literal: 'warrantyProps.propertyType.options.maison'
      },
      {
        key: 'local_commercial',
        literal: 'warrantyProps.propertyType.options.local_commercial'
      }
      ],
      residentTypeOptions: [{
        key: 'propietarie',
        literal: 'warrantyProps.residentType.options.propietarie'
      },
      {
        key: 'locataire',
        literal: 'warrantyProps.residentType.options.locataire'
      },
      {
        key: 'propietarie_non_occupant',
        literal: 'warrantyProps.residentType.options.propietarie_non_occupant'
      }
      ],
      moreThanTwoYearsOptions: [{
        key: true,
        literal: 'warrantyProps.moreThanTwoYears.options.more'
      },
      {
        key: false,
        literal: 'warrantyProps.moreThanTwoYears.options.less'
      }
      ],
      typeValidationSelect: false,
      sinisterData: {},
      countryCallingCode: null,
      selfcareOldClientPhone: 'Numéro de téléphone',
      isoCountryCode: null,
      isPhoneValid: false,
      isEmailValid: false,
      showExtraInfo: null,
      extraInfoAnswered: false,
      isSettingMap: false
    }
  },
  components: {
    maInputText,
    maInputRadio,
    maAccordion,
    maInputBtn,
    maModal,
    maMoreInfoModal,
    maInputSelect,
    VuePhoneNumberInput
  },
  computed: {
    ...mapState({
      agentView: state => state.agentView
    }),
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyAddress: 'address',
      stateWarrantySinisterId: 'sinisterId',
      stateWarrantySecondaryId: 'secondaryId',
      stateWarrantyZipCode: 'zipCode',
      stateWarrantyPropertyType: 'propertyType',
      stateWarrantyResidentType: 'residentType',
      stateWarrantyMoreThanTwoYears: 'moreThanTwoYears',
      stateWarrantyCoordinates: 'coordinates',
      stateWarrantyShowExtraInfo: 'showExtraInfo',
      stateWarrantyAnsweredExtraInfo: 'answeredExtraInfo'
    }),
    ...mapState(USER_MODULE_NAME, {
      stateUserRole: 'role',
      userSinisters: 'userSinisters'
    }),
    ...mapGetters(WARRANTY_MODULE_NAME, {
      getExistingSinister: 'existingSinister'
    }),
    stateComWarrantyAddress: {
      get() {
        return this.stateWarrantyAddress
      },
      set(v) {
        this.mutWarrantySetAddress(v)
      }
    },
    stateComWarrantySinisterId: {
      get() {
        return this.stateWarrantySinisterId
      },
      set(v) {
        this.mutWarrantyUpdateSinisterId(v)
      }
    },
    stateComWarrantyZipCode: {
      get() {
        return this.stateWarrantyZipCode
      },
      set(v) {
        this.mutWarrantySetZipCode(v)
      }
    },
    stateComWarrantyPropertyType: {
      get() {
        return this.stateWarrantyPropertyType
      },
      set(v) {
        this.mutWarrantySetPropertyType(v)
      }
    },
    normalizedPropertyType: {
      get() {
        if (this.stateWarrantyPropertyType === 'appartment') {
          return 'appartement'
        }
        return this.stateWarrantyPropertyType
      },
      set(value) {
        this.mutWarrantySetPropertyType(value)
      }
    },
    stateComWarrantyResidentType: {
      get() {
        return this.stateWarrantyResidentType
      },
      set(v) {
        this.mutWarrantySetResidentType(v)
      }
    },
    stateComWarrantyShowExtraInfo: {
      get() {
        return this.stateWarrantyShowExtraInfo
      },
      set(v) {
        this.mutWarrantySetShowExtraInfo(v)
      }
    },
    stateComWarrantyMoreThanTwoYears: {
      get() {
        return this.stateWarrantyMoreThanTwoYears
      },
      set(v) {
        this.mutWarrantySetMoreThanTwoYears(v)
      }
    },
    stateComWarrantyCoordinates: {
      get() {
        return this.stateWarrantyCoordinates
      },
      set(v) {
        let coordinates = { lat: 0, lng: 0 }

        if (v && v.geometry && v.geometry.location) {
          coordinates.lat =
                        parseFloat(v.geometry.location.lat().toFixed(10)) || 0
          coordinates.lng =
                        parseFloat(v.geometry.location.lng().toFixed(10)) || 0
        } else {
          coordinates = null
        }
        this.mutWarrantySetCoordinates(coordinates)
      }
    },

    showStreetView: function() {
      return (
        this.stateComWarrantyCoordinates &&
                this.stateComWarrantyCoordinates.lat &&
                this.stateComWarrantyCoordinates.lng
      )
    },
    shouldCloseAccordion: function() {
      return this.FNOLFlow.params.closeAccordions
        ? this.FNOLFlow.params.closeAccordions
        : false
    },
    fnolSinisterAddress: function() {
      return this.FNOLFlow.params.addressSin
        ? this.FNOLFlow.params.addressSin
        : null
    },
    fnolSinisterCoordinates: function() {
      return this.FNOLFlow.params.addressSin
        ? {
          lat: this.FNOLFlow.params.addressLatSin,
          lng: this.FNOLFlow.params.addressLngSin
        }
        : null
    },

    fnolSinisterAddressPostcode: function() {
      return this.FNOLFlow.params.addressPostcodeSin
        ? this.FNOLFlow.params.addressPostcodeSin
        : null
    },

    fnolSinisterMoreThanTwoYears: function() {
      return (
        this.FNOLFlow.params.moreThanTwoYears &&
                this.FNOLFlow.params.moreThanTwoYears === 'true'
      )
    },

    fnolSinisterRealEstate: function() {
      return this.FNOLFlow.params.realEstate
    },

    fnolSinisterUserType: function() {
      return this.FNOLFlow.params.userType
    },

    isAgentRole: function() {
      return this.stateUserRole === AGENT_ROLE
    },

    isAllianzFranceRole: function() {
      return this.stateUserRole === ALLIANZ_FRANCE_ROLE
    },

    generateLinkIsDisabled: function() {
      // Disabled functionallity only applies to agent role
      return this.stateUserRole && !this.generateLinkConditions()
    },
    isDiabledPrimaryButton: function() {
      const enabled =
                this.selfcareFlowsValue &&
                this.selfcareValidationTypeValue &&
                (this.isPhoneValid || this.checkEmail())
      return !enabled
    },
    isExtraInfoAnswered: function() {
      return !this.stateWarrantyAnsweredExtraInfo &&
        this.selfcareFlowsValue === 'e2e' &&
        this.stateWarrantyShowExtraInfo
    },
    showMoreInfoModalBtn: function() {
      return (
        (this.stateUserRole === ALLIANZ_FRANCE_ROLE && this.isWaterDamage) ||
                this.stateWarrantyShowExtraInfo
      )
    },

    isWaterDamage: function() {
      return this.sinisterData && this.sinisterData.warranty === 'DDG'
    },

    paramSinisterId: function() {
      const params = this.$route.params
      if (params) {
        return params.sinisterId || ''
      }

      return ''
    },
    isPopupMode: function() {
      return this.getUrlParam('mode') === 'popup'
    },
    countryCodeSelected() {
      return (
        this.selfcareClientPhoneCountry || this.selfcareCountruCodeMavSelector
      )
    },

    userRole: function() {
      const userRoles = ['AllianzDE_user', 'AllianzDE_admin', 'ADMIN_DE']
      return userRoles.includes(localStorage.getItem('mavRole').toString())
    }
  },
  methods: {
    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantySetAddress: WARRANTY_UPDATE_ADDRESS,
      mutWarrantySetPropertyType: WARRANTY_UPDATE_PROPERTY_TYPE,
      mutWarrantySetResidentType: WARRANTY_UPDATE_RESIDENT_TYPE,
      mutWarrantySetMoreThanTwoYears: WARRANTY_UPDATE_MORE_THAN_TWO_YEARS,
      mutWarrantySetZipCode: WARRANTY_UPDATE_ZIP_CODE,
      mutWarrantySetCoordinates: WARRANTY_UPDATE_COORDINATES,
      mutWarrantySetShowExtraInfo: WARRANTY_UPDATE_SHOW_EXTRA_INFO
    }),
    ...mapActions(WARRANTY_MODULE_NAME, {
      actWarrantyUpdateProps: WARRANTY_UPDATE_PROPS
    }),
    initAutocomplete: function() {
      const inputDom = document.getElementsByName('propsAddress')[0] || null
      if (inputDom) {
        // todo: language, offset, sessiontoken
        const options = {
          types: ['geocode'],
          fields: ['address_components', 'formatted_address', 'geometry']
        }
        // Setting country code from local storage as an option
        if (this.countryCode && this.countryCode.length > 0) {
          options.componentRestrictions = { country: [this.countryCode] }
        }
        // eslint-disable-next-line
                const autocompleteObject = new google.maps.places.Autocomplete(
          inputDom,
          options
        )
        // attach handler function
        autocompleteObject.addListener(
          'place_changed',
          function() {
            const place = autocompleteObject.getPlace()
            this.handleSelectPlace(place)
            this.mutWarrantySetAddress(place.formatted_address)
          }.bind(this)
        )
      }
    },

    closeLinkModal() {
      this.$refs.linkModal.closeModal()
      this.showLinkSelfcare = false
    },
    handleSelectPlace: function(place) {
      this.place = place;
      this.$store.commit(
        `${WARRANTY_MODULE_NAME}/WARRANTY_UPDATE_ZIP_CODE`,
        this.getPlacePostalCode(place)
      );
      if (place) {
        this.stateComWarrantyCoordinates = place;

        if (window.self !== window.top && this.panorama) {
          this.$nextTick(() => {
            setTimeout(() => {
              window.google.maps.event.trigger(this.panorama, 'resize');
            }, 300);
          });
        }
      }
    },
    getPlacePostalCode: function(place) {
      let zipCode = ''
      if (place && 'address_components' in place) {
        const addressComponents = place.address_components
        const zipCodeAddressComponent = addressComponents.find(
          addressComponent => {
            if ('types' in addressComponent) {
              return addressComponent.types.includes('postal_code')
            }
            return false
          }
        )
        if (zipCodeAddressComponent && 'long_name' in zipCodeAddressComponent) {
          zipCode = zipCodeAddressComponent.long_name || ''
        }
      }
      return zipCode
    },
    initMap: function() {
      this.service = new window.google.maps.StreetViewService();
      this.panorama = new window.google.maps.StreetViewPanorama(
        document.getElementById('warrantyProps_street-view'),
        {
          zoom: 1,
          visible: true
        }
      );

      if (window.self !== window.top) {
        [100, 300, 500, 1000, 1500].forEach(delay => {
          setTimeout(() => {
            if (this.panorama) {
              window.google.maps.event.trigger(this.panorama, 'resize');
            }
          }, delay);
        });
      }
    },
    initGoogleServices: function() {
      if (window.google) {
        this.initMap()
        this.initAutocomplete()
        if (this.stateComWarrantyCoordinates?.lat && this.stateComWarrantyCoordinates?.lng) {
          this.$nextTick(() => {
            this.setMap()
          })
        }
      } else {
        setTimeout(() => {
          this.initGoogleServices()
        }, 1)
      }
    },
    setPlacePov: function() {
      let pov = {
        heading: 0,
        pitch: 0
      }

      window.google.maps.event.trigger(this.panorama, 'resize');

      this.service.getPanoramaByLocation(
        this.panorama.getPosition(),
        50,
        function(panoData) {
          if (panoData != null) {
            const manLatLng = panoData.location.latLng;
            const targetLatLngObject = new window.google.maps.LatLng(
              this.stateComWarrantyCoordinates.lat,
              this.stateComWarrantyCoordinates.lng
            );

            pov.heading = window.google.maps.geometry.spherical.computeHeading(
              manLatLng,
              targetLatLngObject
            );

            this.panorama.setPov(pov);

            setTimeout(() => {
              this.panorama.setVisible(true);
              window.google.maps.event.trigger(this.panorama, 'resize');

              setTimeout(() => {
                window.google.maps.event.trigger(this.panorama, 'resize');
              }, 200);
            }, 500);
          }
        }.bind(this)
      );
    },
    trackTMO() {
      const sinisterId = this.stateComWarrantySinisterId
        ? this.stateComWarrantySinisterId
        : ''
      const params = {
        description: 'Searching in google street view',
        sinister_id: sinisterId,
        start: this.timeStampStart,
        end: this.timeStampFinish
      }
      apiPostTrackTMO(params).catch(() => {
        throw new Error('Error tracking "Searching in google street view"')
      })
    },
    setSelfcareForms() {
      return new Promise(resolve => {
        apiGetGenericFormsList()
          .then(resp => {
            if (resp && resp.length > 0) {
              this.selfcareForms = resp
              this.selfcareFormsValue = resp[0]['key']
            }
            resolve(resp)
          })
          .catch(() => {
            this.$router.replace({ name: 'error' })
          })
      })
    },
    setSelfcareFnolIds() {
      return new Promise(resolve => {
        apiGetFnolIds()
          .then(resp => {
            if (resp && resp.length >= 0) {
              this.selfcareFnolIds = [
                { key: null, literal: this.$t('common.noSelected') },
                ...resp
              ]
              this.selfcareFnolIdsValue = this.selfcareFnolIds[0].key
            }
            resolve(resp)
          })
          .catch(() => {
            this.$router.replace({ name: 'error' })
          })
      })
    },
    async getUserInfo() {
      await getUser().then(res => {
        this.selfcareAgencyCode = res.agency_code
      })
    },
    setSelfcareFlows() {
      return new Promise(resolve => {
        const locale = Settings.getLocale()

        apiGetFlows({
          role: this.stateUserRole,
          lang: locale
        })
          .then(resp => {
            if (resp && resp.length > 0) {
              this.selfcareFlows = [
                { key: null, literal: this.$t('common.noSelected') },
                ...resp
              ]
              this.selfcareFlowsValue = this.selfcareFlows[0].key
            }
            resolve(resp)
          })
          .catch(() => {
            this.$router.replace({ name: 'error' })
          })
      })
    },
    // Show email in dev enviroment
    setSelfCareValidatorEnv() {
      if (process.env.NODE_ENV === 'pro') {
        this.typeValidationSelect = true
        this.selfcareValidationTypeValue = SMS
      }
    },
    handleOpenModal() {
      Promise.all([
        this.setSelfcareForms(),
        this.setSelfcareFnolIds(),
        this.setSelfcareFlows(),
        this.setSelfCareValidatorEnv()
      ]).then(() => {
        if (this.selfcareFormsValue && this.selfcareFnolIds.length >= 0) {
          this.$refs.linkModal.showModal = true
          this.getInfoModalData()
        }
      })
    },

    openMoreInfoModalLink() {
      const sinisterId = this.stateComWarrantySinisterId
        ? this.stateComWarrantySinisterId
        : ''
      this.$router.push({
        name: 'extraInfo',
        params: { sinisterId: sinisterId }
      })
      // this.$refs.moreInfoModal.open()
    },

    checkPhone(phoneNumber, countryCode) {
      const payload = { phoneNumber, countryCode }
      const phone = this.$refs.phoneNumberInput.getParsePhoneNumberFromString(
        payload
      )
      return this.selfcareValidationTypeValue === SMS && phone.isValid
    },
    checkEmail() {
      return (
        this.selfcareValidationTypeValue === EMAIL &&
                validateEmail(this.selfcareClientEmailRaw)
      )
    },

    generateLinkConditions() {
      return (
        this.stateComWarrantySinisterId &&
                this.stateWarrantyCoordinates &&
                this.stateWarrantyZipCode &&
                this.stateComWarrantyPropertyType &&
                this.stateComWarrantyResidentType &&
                this.stateComWarrantyMoreThanTwoYears !== null &&
                this.stateComWarrantyAddress &&
                this.selfcareValidationTypeOptions
      )
    },
    generateLinkConditionsWithPhone() {
      return (
        this.stateComWarrantySinisterId &&
                this.stateWarrantyCoordinates &&
                this.stateWarrantyZipCode &&
                this.stateComWarrantyPropertyType &&
                this.stateComWarrantyResidentType &&
                this.stateComWarrantyMoreThanTwoYears &&
                this.stateComWarrantyAddress &&
                this.selfcareValidationTypeValue &&
                this.selfcareValidationTypeOptions
      )
    },
    handleOnPhoneNumberUpdate(payload) {
      this.setPhoneNumber(
        payload.formattedNumber || payload.phoneNumber,
        payload.countryCode
      )
    },
    handleOnEmailChange(newMail) {
      if (newMail && !newMail.includes(EMAIL_MASK)) {
        this.selfcareClientEmailRaw = newMail
      }
    },
    handleGenerateLink() {
      if (this.generateLinkConditions()) {
        const defaultWarrantyValue = 'DDE'
        apiCreateSinister({
          sinister_id: this.stateComWarrantySinisterId,
          event_id: this.stateWarrantySecondaryId,
          lat: this.stateWarrantyCoordinates.lat,
          lon: this.stateWarrantyCoordinates.lng,
          zip_code: this.stateWarrantyZipCode,
          real_estate: this.stateComWarrantyPropertyType,
          declarant: this.stateComWarrantyResidentType,
          more_than_two_years: this.stateComWarrantyMoreThanTwoYears,
          address: this.stateComWarrantyAddress,
          form_id: this.selfcareFormsValue,
          phone_number: this.selfcareClientPhoneNew,
          phone_country: this.selfcareClientPhoneCountry,
          id_flux: this.selfcareFnolIdsValue,
          sc_flux_id: this.selfcareFlowsValue,
          warranty: defaultWarrantyValue,
          email: this.selfcareClientEmailRaw,
          is_email: this.selfcareValidationTypeValue === EMAIL,
          agency_code: this.selfcareAgencyCode
        }).then(res => {
          this.showLinkSelfcare = true
          this.linkSelfCare = res.url
        })
      } else {
        this.throwNotification(
          this.$t(`notifications.error.${400}.title`),
          this.$t(`notifications.error.${400}.body`),
          'KO'
        )
      }
    },
    setMap() {
      if (
        this.showStreetView &&
        typeof this.stateComWarrantyCoordinates.lat !== 'number'
      ) {
        const lat = parseFloat(this.stateComWarrantyCoordinates.lat)
        const lng = parseFloat(this.stateComWarrantyCoordinates.lng)

        const position = new window.google.maps.LatLng(lat, lng)
        this.panorama.setPosition(position)
        this.setPlacePov()

        return
      }

      this.panorama.setPosition(this.stateComWarrantyCoordinates);
      this.setPlacePov();
    },

    setSinisterAddress() {
      if (this.fnolSinisterAddress) {
        this.mutWarrantySetAddress(this.fnolSinisterAddress)
      }
      if (this.fnolSinisterAddressPostcode) {
        this.mutWarrantySetZipCode(this.fnolSinisterAddressPostcode)
      }
      if (this.fnolSinisterMoreThanTwoYears !== null) {
        this.mutWarrantySetMoreThanTwoYears(this.fnolSinisterMoreThanTwoYears)
      }
      if (this.fnolSinisterRealEstate) {
        this.mutWarrantySetPropertyType(this.fnolSinisterRealEstate)
      }
      if (this.fnolSinisterUserType) {
        this.mutWarrantySetResidentType(this.fnolSinisterUserType)
      }
      if (this.fnolSinisterCoordinates && this.fnolSinisterCoordinates.lat) {
        const rawLat = parseFloat(this.fnolSinisterCoordinates.lat)
        const rawLng = parseFloat(this.fnolSinisterCoordinates.lng)

        let coordinates = {
          lat: !isNaN(rawLat) ? parseFloat(rawLat.toFixed(10)) : 0,
          lng: !isNaN(rawLng) ? parseFloat(rawLng.toFixed(10)) : 0
        }

        this.mutWarrantySetCoordinates(coordinates)
      }
      this.$store.commit(`${WARRANTY_MODULE_NAME}/WARRANTY_UPDATE_CREATED`, true)
      this.actWarrantyUpdateProps()
    },
    getSinisterData: function(sinisterId) {
      return this.userSinisters.find(
        sinister => sinister.sinister_id === sinisterId
      )
    },

    getUrlParam: function(key) {
      const querystring = window.location.search
      const params = new URLSearchParams(querystring)
      return params.get(key)
    },

    async onMoreInfoModalClose(openLinkModal) {
      if (openLinkModal) {
        this.handleOpenModal()
      }
    },

    setLinkModalData(data) {
      this.selfcareFlowsValue = data.sc_flux_id
      this.selfcareFnolIdsValue = data.id_flux || null

      if (data.is_email) {
        this.selfcareValidationTypeValue = EMAIL
        this.setEmail(data.recipient)
        this.setEmailInfo(data.recipient)
      } else {
        this.selfcareValidationTypeValue = SMS
        this.selfcareClientPhone = null
        this.setPhoneNumber(data.recipient, data.phone_country)
      }
    },

    setPhoneNumber(phoneNumber, phoneCountry) {
      this.selfcareClientPhoneCountry = phoneCountry || this.countryCodeSelected

      if (phoneNumber) {
        this.selfcareClientPhoneNew = phoneNumber
      }
      this.isPhoneValid = this.checkPhone(
        this.selfcareClientPhoneNew,
        this.selfcareClientPhoneCountry
      )
      this.isoCountryCode = this.getPhoneCountryInfo(
        this.selfcareClientPhoneCountry
      )
    },

    setEmail(email) {
      this.selfcareClientEmailRaw = email
      this.isEmailValid = this.checkEmail(email)
    },

    getInfoModalData() {
      return new Promise(resolve => {
        getSelfcareLinkData(this.stateComWarrantySinisterId)
          .then(resp => {
            if (resp.length === 0) {
              return
            } else {
              this.setLinkModalData(resp)
            }
            resolve(resp)
          })
          .catch(e => {
            console.error(`Error ${e}`)
          })
      })
    },
    getPhoneCountryInfo(countryCode) {
      const arrayCodes = this.$refs.phoneNumberInput.codesCountries
      for (let i = 0; i < arrayCodes.length; i++) {
        const isoCountryCode = arrayCodes[i]
        if (isoCountryCode.iso2 === countryCode) {
          return isoCountryCode
        }
      }
    },
    getEncryptedPhone() {
      const phoneComplete = this.selfcareClientPhoneNew

      if (!this.isPhoneValid) {
        return ''
      }
      const countryCodeDialCode = this.isoCountryCode.dialCode

      const countryCodeLength = countryCodeDialCode.length + 1

      const phoneWithoutCode = phoneComplete.slice(
        countryCodeLength,
        phoneComplete.length
      )

      const phoneForReplace = phoneWithoutCode.split(
        '',
        phoneWithoutCode.length - 3
      )
      const phoneToShow = phoneWithoutCode.substr(phoneWithoutCode.length - 3)

      let encryptedNumber = phoneForReplace.map(function(x) {
        return (x = '*')
      })
      const encrytedPhoneObject = encryptedNumber.concat(phoneToShow)
      return encrytedPhoneObject.join('')
    },
    setEmailInfo(emailInfo) {
      this.selfcareClientEmail = this.getEncryptedMail(emailInfo)
    },
    getEncryptedMail(emailInfo) {
      const separateEmail = emailInfo.split('@')
      const emailWithoutDomain = separateEmail[0]
      const splitEmail = emailWithoutDomain.slice(2, emailInfo.length)
      return emailInfo.replace(splitEmail, 'xxxxxxx')
    },
    handleSelfcareFlowsValue (event) {
      this.selfcareFlowsValue = event

      if (this.selfcareFlowsValue === 'e2e') {
        this.selfcareFnolIdsValue = 1
      }
    },
    async handleChangeOption(value, type) {
      switch (type) {
        case 'property':
          this.stateComWarrantyPropertyType = value
          break
        case 'resident':
          this.stateComWarrantyResidentType = value
          break
        case 'moreThanTwoYears':
          this.stateComWarrantyMoreThanTwoYears = value
          break
      }
      await apiPostSinister(
        this.stateComWarrantySinisterId || null,
        this.stateComWarrantyZipCode || null,
        this.stateComWarrantyMoreThanTwoYears !== null ? this.stateComWarrantyMoreThanTwoYears : false,
        this.stateComWarrantyPropertyType || null,
        this.stateComWarrantyResidentType || null,
        this.stateComWarrantyCoordinates.lat || null,
        this.stateComWarrantyCoordinates.lng || null,
        this.stateComWarrantyAddress || null,
        this.showExtraInfo || false
      )
    },
    checkRequiredFields() {
      return (
        this.stateComWarrantyPropertyType &&
        this.stateComWarrantyResidentType &&
        this.stateComWarrantyMoreThanTwoYears !== null &&
        this.stateComWarrantyAddress &&
        this.stateComWarrantySinisterId
      )
    },
    /**
     * @name showRequiredFieldsMessage
     * @description Show a notification if the required fields are not filled
     * @returns {void}
     */
    showRequiredFieldsMessage() {
      if (this.$route.params.sinisterId && !this.generateLinkConditions()) {
        this.throwNotification(
          this.$t('warrantyProps.requiredFields.title'),
          this.$t('warrantyProps.requiredFields.body'),
          'KO'
        )
      }
    }
  },
  beforeMount() {
    // unselect options only for FR
    if (Settings.getLocale() === 'fr') {
      this.mutWarrantySetResidentType(null)
      this.mutWarrantySetPropertyType(null)
      this.mutWarrantySetMoreThanTwoYears(null)
    }
  },
  mounted: async function() {
    await this.getUserInfo()

    this.sinisterData = await this.getSinisterData(this.paramSinisterId)
    const mode = this.getUrlParam('mode')
    const openLinkModal = this.getUrlParam('openLinkModal')
    if (mode === 'popup') {
      this.$router.push({
        name: 'extraInfo',
        params: { sinisterId: this.paramSinisterId }
      })
      // this.openMoreInfoModalLink()
    }
    if (openLinkModal) {
      this.handleOpenModal()
    }

    this.countryCode = localStorage.getItem('mavCountryCode')
    this.selfcareValidationTypeValue = this.selfcareValidationTypeOptions[0].key
    if (Settings.getLocale().toUpperCase() === 'EN') {
      this.selfcareCountruCodeMavSelector = 'GB'
      this.selfcareClientPhoneCountry = 'GB'
    } else {
      this.selfcareCountruCodeMavSelector = Settings.getLocale().toUpperCase()
      this.selfcareClientPhoneCountry = Settings.getLocale().toUpperCase()
    }

    this.initGoogleServices()
    if (!this.shouldCloseAccordion) {
      maEventBus.$on('props:expand', () =>
        this.$refs.propsAccordion.showContent()
      )
      maEventBus.$on('props:resize', () =>
        this.$refs.propsAccordion.resizeContent()
      )
    }
    document
      .querySelectorAll(
        '.warrantyProps .accordion__bottom .input:last-child input'
      )
      .forEach(el => {
        el.addEventListener('keydown', e => {
          if (e.keyCode === 9) {
            let firstInputWrapper = document.querySelector(
              '.warranty__content .form .grid__row:first-child .input:first-child > div'
            )
            if (hasClass(firstInputWrapper, 'input--select')) {
              setTimeout(() => {
                firstInputWrapper.querySelector('input').blur()
                this.$refs.propsAccordion.hideContent()
              }, 1)
              setTimeout(() => {
                firstInputWrapper.querySelector('input').focus()
              }, 500)
            } else {
              this.$refs.propsAccordion.hideContent()
            }
          }
        })
      })

    if (this.panorama && this.stateComWarrantyCoordinates) {
      this.setMap()
    }
    if (
      this.fnolSinisterAddress ||
            this.fnolSinisterAddressPostcode ||
            this.fnolSinisterMoreThanTwoYears ||
            this.fnolSinisterRealEstate ||
            this.fnolSinisterUserType ||
            this.fnolSinisterCoordinates
    ) {
      setTimeout(() => this.setSinisterAddress(), 500)
    }

    setTimeout(() => this.showRequiredFieldsMessage(), 1000)
  },
  watch: {
    showStreetView(newVal) {
      if (newVal && this.panorama) {
        this.$nextTick(() => {
          window.google.maps.event.trigger(this.panorama, 'resize');
        });
      }
    },
    stateComWarrantyCoordinates: function() {
      if (this.panorama && this.stateComWarrantyCoordinates && !this.isSettingMap) {
        this.isSettingMap = true;

        this.timeStampStart = setTimeStamp.call()
        this.setMap()

        if (window.self !== window.top) {
          this.$nextTick(() => {
            [100, 300, 500, 1000].forEach(delay => {
              setTimeout(() => {
                if (this.panorama) {
                  window.google.maps.event.trigger(this.panorama, 'resize');
                }
              }, delay);
            });
          });
        }

        this.timeStampFinish = setTimeStamp.call()
        this.trackTMO()

        if (
          this.stateComWarrantyCoordinates.lat &&
          typeof this.stateComWarrantyCoordinates.lat === 'number'
        ) {
          this.isSettingMap = false;
          return
        }

        this.actWarrantyUpdateProps().catch(errorCode => {
          this.throwNotification(
            this.$t(`notifications.error.${errorCode}.title`),
            null,
            'KO'
          )
        }).finally(() => {
          this.isSettingMap = false;
        })
      }
    },
    $route() {
      if (
        this.fnolSinisterAddress ||
                this.fnolSinisterAddressPostcode ||
                this.fnolSinisterMoreThanTwoYears ||
                this.fnolSinisterRealEstate ||
                this.fnolSinisterUserType ||
                this.fnolSinisterCoordinates
      ) {
        setTimeout(() => this.setSinisterAddress(), 500)
      }
    }
  }
}
